













































































































































import Group from '@/types/Group.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import GroupSelector from '@/components/GroupSelector.vue'
export default Vue.extend({
    components: { GroupSelector },
    data() {
        return {
            group: null,
            groupCheckbox: false,
            //  Determines if we are ready to start using the page
            mounted: false,
            searchOptions: ['Phone Number', 'First and Last Name', 'Full Name', 'Email'],
            selectedSearch: 'Phone Number',
            goto: null
        }
    },
    async mounted() {
        if (this.$route.query.goto) this.goto = this.$route.query.goto
        //  Grab the new group query from our path
        const newGroup = this.$route.query.new_group

        //  Grab the group query from our path
        const groupId = this.$route.query.group

        //  If a new group needs to be created, pre-select group create/update checkbox
        if (newGroup) this.groupCheckbox = true

        //  If group was NOT passed, do nothing
        if (!groupId) return (this.mounted = true)

        //  Else, if a group id was passed
        //  Set the group id on importGroup
        this.$store.commit('importGroupSet', groupId)

        //  Get the group
        const group = await this.$store.dispatch('groupsFind', this.$route.query.group)

        //  Set the group on the group-selector
        if (group) this.group = group

        //  We're done so mark mounted as true
        this.mounted = true
    },
    computed: {
        ...mapGetters(['importGroup', 'importMatched']),
        overwrite: {
            get(): object {
                return this.$store.getters.importOverwrite
            },
            set(value: object): void {
                this.$store.commit('importOverwriteSet', value)
            }
        }
    },
    methods: {
        back(): void {
            this.$emit('back')
        },
        dialogsExist(): boolean {
            //  Grab our app dialogs
            const app = this.$store.getters.dialogApp

            //  Grab our confirm dialogs
            const confirm = this.$store.getters.dialogConfirm

            //  Grab our message dialogs
            const message = this.$store.getters.dialogMessage

            //  Grab our feature dialogs
            const feature = this.$store.getters.dialogFeature

            //  If ANY of these have a length > 0 then return true
            return app.length || confirm.length || message.length || feature.length
        },
        groupCheckboxChanged(bool: boolean): void {
            //  If unchecked and goto includes broadcasts
            if (!bool && this.goto && this.goto.includes('broadcast')) {
                //  Notify user that hey won't be navigated back to broadcasts if no group is selected to import to
                this.popGroupUncheckedError()
            }
            //  If the group checkbox is toggled off, reset importGroup
            if (!bool) this.$store.commit('importGroupSet', null)
        },
        next(): void {
            //  Grab our group selector component
            const selector = this.$refs.groupSelector

            //  If it exists, then blur it
            if (selector) selector.$refs.groupSelect.blur()

            // const dialogsExist = this.$nextTick(this.dialogsExist())
            this.$nextTick(() => {
                //  Check if we already have a dialog, and if we do, do nothing
                if (this.dialogsExist()) return

                //  If user checked the import to group box, make sure they selected a group
                if (this.groupCheckbox && !this.importGroup) {
                    return this.$store.dispatch('dialogOpen', {
                        type: 'MESSAGE',
                        title: 'Error',
                        icon: 'mdi-alert',
                        color: 'primary',
                        text: 'Please select a group to import your contacts into!'
                    })
                }

                //  If import group is not set and query contains goto
                if (!this.$store.getters.importGroup && this.goto) {
                    // Copy query object from router
                    let query = Object.assign({}, this.$route.query)

                    // Delete goto query param
                    delete query.goto

                    // Replace new router link with new query
                    this.$router.replace({ query })
                }

                //  Set the csv search (Phone Number by default)
                this.$store.commit('importSearchSet', this.selectedSearch)

                //  Reset group checkbox
                this.groupCheckbox = null

                //  Reset selected search
                this.selectedSearch = 'Phone Number'

                //  Begin import in CsvImport
                this.$emit('next')
            })
        },
        groupSelected(group: Group): void {
            //  When a group is selected in group-selector, set the importGroup
            this.$store.commit('importGroupSet', group.id)
        },
        popGroupUncheckedError(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Import into group unchecked',
                text: 'Not importing contacts from CSV to new or existing group will result in not being navigated back to broadcasts.',
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        },
        overwriteHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Update Existing Contacts',
                text: 'Messagedesk will replace exisiting contact information with the fields provided in your .CSV file',
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        },
        groupHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Update Existing Contacts',
                text: "You can import your contact list from this .csv file directly into a group. Start by selecting an existing group that you've already made, or create a new one and directly import your contacts.",
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        }
    }
})
